(function(){
     'use strict';

     angular
        .module('app')
        .factory('OfertaService', OfertaService);

    OfertaService.$inject = ['$http'];

    function OfertaService($http){
        
        var service= {
            Ofertaform:Ofertaform,
        };

         function Ofertaform(vm){
            var config = {
                headers : {
                   // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            
            return $http.post('/ajax/realizaroferta', {
                user_id:vm.user_id,
                activo_id:vm.activo_id,
                precio:vm.precio,
                fecha_oferta:vm.fecha_oferta,
                firma_oferta:vm.signature,

             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };
       

        return service;
    }

     
})();